import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    schoolManagers: []
};

const schoolManagerSlice = createSlice({
    name: "schoolManager",
    initialState,
    reducers: {
        setSchoolManagers(state, action) {
            state.schoolManagers = action.payload;
        },
        addSchoolManager(state, action) {
            const { id, permissionLevelId } = action.payload;
            const member = state.schoolManagers.find(m => m.id === id);
            if (member) {
                member.isManager = true;
                member.permissionLevelId = permissionLevelId;
            }
        },
        removeSchoolManager(state, action) {
            const member = state.schoolManagers.find(m => m.id === action.payload);
            if (member) {
                member.isManager = false;
                member.permissionLevelId = null;
            }
        }
    }
});

export const { setSchoolManagers, addSchoolManager, removeSchoolManager } = schoolManagerSlice.actions;
export default schoolManagerSlice;
